<textarea [rows]="rows" (blur)="onBlur()" [placeholder]="placeholder" [ngClass]="getClasses()" [id]="htmlId" [formControl]="control" class="form-textarea" #textarea [readOnly]="isReadonly ? 'readonly' : ''"></textarea>
